import React from 'react'
import ChevronDownIcon from '../icons/chevron-down.svg'
import { createUseStyles } from '../helpers/createStyles'
import { theme } from '../styles/theme'

const Arrow = ({ direction = 'down', heightSM = 12, heightMD = 24, onClick, isDisabled }) => {
  document.documentElement.style.setProperty('--arrow-height-sm', `${heightSM}px`)
  document.documentElement.style.setProperty('--arrow-height-md', `${heightMD}px`)
  const classes = useStyles()

  const getDirectionClass = () => {
    switch (direction) {
      case 'up':
        return 'up'
      case 'down':
        return 'down'
      case 'left':
        return 'left'
      case 'right':
        return 'right'
      default:
        return 'down'
    }
  }

  return (
    <div
      className={`${classes.arrow} ${getDirectionClass()} ${isDisabled ? 'disabled' : ''}`}
      onClick={!isDisabled ? onClick : undefined}
    >
      <ChevronDownIcon />
    </div>
  )
}
const useStyles = createUseStyles({
  arrow: {
    height: 'var(--arrow-height-sm)',
    width: 'var(--arrow-height-sm)',
    transition: 'all 0.3s ease-in-out',
    color: theme.colors.black,
    opacity: 1,
    pointerEvents: 'all',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '&.left': {
      transform: 'rotate(90deg)'
    },
    '&.right': {
      transform: 'rotate(-90deg)'
    },
    '&.up': {
      transform: 'rotate(180deg)'
    },
    '&.down': {
      transform: 'rotate(0deg)'
    },
    '& svg': {
      width: '100%'
    },
    '&.disabled': {
      cursor: 'not-allowed',
      opacity: 0.2
    },

    [theme.breakpoints.up('md')]: {
      height: 'var(--arrow-height-md)',
      width: 'var(--arrow-height-md)'
    }
  }
})
export default Arrow

// Todo: finish this component and use it for the accordion, carousel, and detail picker components
